import { SET_MODAL_SETTINGS } from './types';

export function setModalSettings(data) {
	return {
		type: SET_MODAL_SETTINGS,
		payload: data
	};
}



// WEBPACK FOOTER //
// ./src/actions/modalSettings.js